import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { client, urlFor } from "../../client";
import "./AllCategories.scss";
import { AppWrap } from "../../wrapper";
import { DotLoader } from "react-spinners";

const TagBlogs = () => {
  const { tag } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == 'blog' && references(*[_type == 'tag' && slug.current == "${tag}"][0]._id)] | order(publishedAt desc)`;
    client.fetch(query).then((data) => {
      setBlogs(data);
      setLoading(false);
    });
  }, [tag]);

  return (
    <div className="app__all-blogs">
      <h2 className="head-text">
        Blogs with <span># {tag}</span>
      </h2>
      {loading ? (
        <div className="loader-container">
          <DotLoader color="#3498db" size={50} />
        </div>
      ) : blogs.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "2rem" }}>
          No blogs found with this tag.
        </p>
      ) : (
        <div className="app__all-blogs-container">
          {blogs.map((blog, index) => (
            <div className="app__all-blog-item" key={blog.slug.current + index}>
              <Link to={`/blogs/${blog.slug.current}`} className="blog-link">
                <img src={urlFor(blog.mainImage)} alt={blog.title} />
                <h3 className="bold-text">{blog.title}</h3>
                <p className="p-text">{blog.description}</p>
                <p
                  className="p-text"
                  style={{ marginTop: 10, color: "#6b7688" }}
                >
                  Published on:{" "}
                  {new Date(blog.publishedAt).toLocaleDateString()}
                </p>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppWrap(TagBlogs, "tagblogs");
